var _path, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMortgage = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5256 22.4377L18.564 20.0002C18.504 19.8483 18.364 19.75 18.2086 19.75H16.2854C16.13 19.75 15.99 19.8483 15.93 20.0002L14.9684 22.4377C14.9191 22.5629 14.9322 22.7059 15.0038 22.8188C15.0753 22.9326 15.1953 23 15.3238 23H19.1702C19.2987 23 19.4187 22.9326 19.4902 22.8188C19.5618 22.7059 19.5748 22.5629 19.5256 22.4377Z",
    fill: "#FFEBF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6022 22.4377L21.6429 20.0002C21.5829 19.8491 21.4429 19.75 21.2875 19.75H19.3589C19.2473 19.75 19.145 19.802 19.0735 19.8865L19.9974 22.2297C20.0959 22.4808 20.0812 22.7587 19.972 23H22.2468C22.3752 23 22.4952 22.9326 22.5668 22.8188C22.6383 22.7067 22.6514 22.5629 22.6022 22.4377Z",
    fill: "#FFEBF6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0636 18.6456L20.102 16.2081C20.042 16.0562 19.9019 15.9579 19.7466 15.9579H17.8234C17.668 15.9579 17.528 16.0562 17.4679 16.2081L16.5063 18.6456C16.4571 18.7708 16.4702 18.9138 16.5417 19.0267C16.6133 19.1396 16.7333 19.2079 16.8618 19.2079H20.7082C20.8366 19.2079 20.9566 19.1404 21.0282 19.0267C21.0997 18.9138 21.1128 18.7716 21.0636 18.6456Z",
    fill: "#FFEBF6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.884 12.4375H16.995L17.882 11.6876C18.1843 11.4332 18.2966 11.0197 18.1689 10.6337C18.042 10.2494 17.7097 10 17.3243 10H12.5547C12.1693 10 11.837 10.2494 11.7093 10.6346C11.5816 11.0197 11.6939 11.4332 11.9962 11.6876L12.884 12.4375Z",
    fill: "#FFEBF6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2581 22.1261L15.2197 19.6878C15.3251 19.4205 15.5174 19.219 15.749 19.0898C15.6913 18.8412 15.7005 18.578 15.7967 18.335L16.7583 15.8967C16.9383 15.4409 17.356 15.1468 17.8237 15.1468H18.4007C18.0168 14.4245 17.5622 13.7663 17.0644 13.2512H12.8134C11.4125 14.7023 10.3232 17.2495 10.3232 19.3433C10.3232 21.1633 11.2348 22.9996 13.2719 22.9996H14.235C14.1412 22.7184 14.1466 22.4073 14.2581 22.1261Z",
    fill: "#FFEBF6"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMortgage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_mortgage.d95f321be0a7ecf1150b964466a56fb2.svg";